document.addEventListener("DOMContentLoaded", function () {
  // Fonction d'aide pour supprimer les balises HTML d'une chaîne
  function stripHTML(html) {
    var tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    return tempDiv.textContent || tempDiv.innerText || "";
  }

  // Récupère le wrapper sticky
  const stickyWrapper = document.getElementById("sticky-wrapper");
  if (!stickyWrapper) return;

  // Récupère les éléments internes du sticky add-to-cart
  const addToCartButton = stickyWrapper.querySelector(".add-to-cart");
  if (!addToCartButton) return;
  const spanText = addToCartButton.querySelector("[data-add-to-cart-text]");
  const variantInfoContainer = stickyWrapper.querySelector(".sticky-variant-info");
  if (!spanText || !variantInfoContainer) return;
  const variantImageEl = variantInfoContainer.querySelector(".sticky-variant-image");
  const variantTitleEl = variantInfoContainer.querySelector(".sticky-variant-title");
  const variantSelect = document.querySelector('select[name="id"]');

  // Récupère les données par défaut passées via Liquid sur le wrapper
  const defaultText = stickyWrapper.getAttribute("data-default-text");
  const soldOutText = stickyWrapper.getAttribute("data-sold-out-text");
  const defaultImageSrc = stickyWrapper.getAttribute("data-default-image-src");
  const defaultImageAlt = stickyWrapper.getAttribute("data-default-image-alt");
  const currencyFormat = stickyWrapper.getAttribute("data-currency-format");

  // Récupère le JSON des variants injecté via Liquid
  const variantJsonEl = document.querySelector('[data-variant-json]');
  let variants = [];
  if (variantJsonEl) {
    try {
      variants = JSON.parse(variantJsonEl.value);
    } catch (e) {
      console.error("Erreur lors du parsing du JSON des variants :", e);
    }
  }

  // Fonction pour mettre à jour les informations affichées dans le sticky
  const updateVariantInfo = () => {
    // Récupère les options sélectionnées via les inputs radio (s'il y en a)
    let selectedOptions = {};
    const radioInputs = document.querySelectorAll('input[data-variant-input]');
    radioInputs.forEach(radio => {
      if (radio.checked) {
        // On suppose que data-index correspond à "option1", "option2", etc.
        selectedOptions[radio.getAttribute("data-index")] = radio.value.trim().toLowerCase();
      }
    });

    // Recherche le variant correspondant
    let selectedVariant;
    if (Object.keys(selectedOptions).length > 0) {
      selectedVariant = variants.find(v =>
        Object.keys(selectedOptions).every(key => {
          return v[key] && v[key].trim().toLowerCase() === selectedOptions[key];
        })
      );
    }
    // Si aucun radio n'est utilisé ou aucune correspondance n'est trouvée, on se base sur la sélection du <select>
    if (!selectedVariant && variantSelect) {
      selectedVariant = variants.find(v => String(v.id) === variantSelect.value);
    }

    if (selectedVariant) {
      // Mise à jour du titre et du prix dans le sticky variant info
      if (variantTitleEl) {
        // On formate le prix à l'aide de la fonction theme.Currency.formatMoney (définie ailleurs dans le thème)
        const formattedPrice = theme.Currency.formatMoney(selectedVariant.price, currencyFormat);
        const cleanPrice = stripHTML(formattedPrice);
        variantTitleEl.textContent = selectedVariant.title + " - " + cleanPrice;
      }

      // Mise à jour du texte du bouton en fonction de la disponibilité
      if (!selectedVariant.available) {
        spanText.innerHTML = soldOutText;
      } else {
        spanText.innerHTML = defaultText;
      }

      // Mise à jour de l'image affichée dans le sticky
      if (selectedVariant.featured_image && selectedVariant.featured_image.src) {
        variantImageEl.src = selectedVariant.featured_image.src + "?width=100";
        variantImageEl.alt = selectedVariant.title;
      } else {
        variantImageEl.src = defaultImageSrc;
        variantImageEl.alt = defaultImageAlt;
      }
    }
  };

  // Met à jour les informations lorsque le <select> change
  if (variantSelect) {
    variantSelect.addEventListener("change", updateVariantInfo);
  }

  // Met à jour lorsque les inputs radio changent
  const radios = document.querySelectorAll('input[data-variant-input]');
  radios.forEach(radio => {
    radio.addEventListener("change", function () {
      // Reconstruit l'objet des options sélectionnées
      let selectedOptions = {};
      radios.forEach(r => {
        if (r.checked) {
          selectedOptions[r.getAttribute("data-index")] = r.value.trim().toLowerCase();
        }
      });
      // Recherche le variant correspondant
      const matchedVariant = variants.find(v =>
        Object.keys(selectedOptions).every(key => {
          return v[key] && v[key].trim().toLowerCase() === selectedOptions[key];
        })
      );
      // Met à jour la valeur du <select> pour rester en synchro
      if (matchedVariant && variantSelect) {
        variantSelect.value = matchedVariant.id;
      }
      updateVariantInfo();
    });
  });

  // Écoute l'événement personnalisé variant:change (si déclenché par Shopify ou un autre script)
  document.addEventListener("variant:change", function (e) {
    if (e.detail && e.detail.variant) {
      updateVariantInfo();
    }
  });

  // Si la classe du sticky wrapper change (par exemple, lors du passage en sticky), on met à jour les infos
  const observer = new MutationObserver(() => {
    updateVariantInfo();
  });
  observer.observe(stickyWrapper, { attributes: true, attributeFilter: ["class"] });

  // Mise à jour initiale au chargement de la page
  updateVariantInfo();
});
